export const UPDATE_SEARCH_FILTER = "UPDATE_SEARCH_FILTER"
export const UPDATE_APPLIED_FILTERS = "UPDATE_APPLIED_FILTERS"

export const updateSearchFilter = (filters) => dispatch => {
    dispatch({ type: UPDATE_SEARCH_FILTER, payload: filters })
}

export const updateAppliedFilter = (appliedFilters) => dispatch => {
    dispatch({ type: UPDATE_APPLIED_FILTERS, payload: appliedFilters })
}